import { useEffect } from "react";
import NewTarget from "../../../../../components/AssetManagement/Overview/WebsiteTarget/SetNewTarget/NewTarget";
import { useSearchParams } from "react-router-dom";
import { websiteTargetEndPointLogic } from "../../../../../logic/AssetManagement/WebsiteTarget/websiteTargetEndPointLogic";
import { useDispatch } from "react-redux";
import { setDisplayErrorSnackBar } from "../../../../../features/userSlice";

const NewTargetScreen = (userToken: any) => {
  const oauthTokenHeader = userToken?.userToken;
  const Websiteresponse = userToken?.response;
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const selectedSharedUid = searchParams.get("selectedSite") as any;

  //-- this for get all website target and store redux (when user refresh this page it will get data from redux)
  useEffect(() => {
    const fetchTargetData = async () => {
            try {
              await websiteTargetEndPointLogic.getAllWebsiteTarget(
                oauthTokenHeader,
                selectedSharedUid,
                dispatch
              );
             
            } catch (error: any) {
              dispatch(
                setDisplayErrorSnackBar({
                  message:
                    error?.parsedText ||
                    "Error while fetching data. Please try again later.",
                  type: "error",
                })
              );
            } 
          };
          fetchTargetData();
  },
  // eslint-disable-next-line
  [oauthTokenHeader,selectedSharedUid]);

  return (
    <>
      <NewTarget
        oauthTokenHeader={oauthTokenHeader}
        response={Websiteresponse}
      />
    </>
  );
};

export default NewTargetScreen;
